/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SupportRequestResponseDTOFromJSON, SupportRequestResponseDTOToJSON, } from './SupportRequestResponseDTO';
/**
 * Check if a given object implements the PaginatedResponseSupportRequestResponseDTO interface.
 */
export function instanceOfPaginatedResponseSupportRequestResponseDTO(value) {
    return true;
}
export function PaginatedResponseSupportRequestResponseDTOFromJSON(json) {
    return PaginatedResponseSupportRequestResponseDTOFromJSONTyped(json, false);
}
export function PaginatedResponseSupportRequestResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'items': json['items'] == null ? undefined : (json['items'].map(SupportRequestResponseDTOFromJSON)),
    };
}
export function PaginatedResponseSupportRequestResponseDTOToJSON(json) {
    return PaginatedResponseSupportRequestResponseDTOToJSONTyped(json, false);
}
export function PaginatedResponseSupportRequestResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'currentPage': value['currentPage'],
        'totalCount': value['totalCount'],
        'items': value['items'] == null ? undefined : (value['items'].map(SupportRequestResponseDTOToJSON)),
    };
}
